export const tabData = {
    'CLIENT': 'User',
    'PILOT': 'Pilot'
}
export const tabDescription ={
    'PILOT':'Note: We kindly request that you use the first name and last name, along with the address you have provided for your FAA account. This information will be used for account validation and verification purposes. Thank you.'
}

export const defaultLocation = {
    lng: -73.9484449185478,
    lat: 40.679494793008914
}

export const cardBGColor = {
    'pending': 'bedge',
    'pilotassigned': 'skyblue',
    'workstarted': 'skyblue',
    'completed': 'green'
}

export const getFormattedDate = (value) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    const formattedDate = new Date(value);
    const date = formattedDate.getDate();
    const month = formattedDate.getMonth();
    const year = formattedDate.getFullYear();

    return `${months[month]} ${date}, ${year}`;
}

// export const getRelativeTime = (timestamp) => {
//     const now = new Date();
//     const then = new Date(timestamp);

//     const difference = now - then;
//     const hoursAgo = Math.floor(difference / (1000 * 60 * 60));

//     let timeString;

//     if (hoursAgo < 24) {
//         if (hoursAgo === 0) {
//             return 'Just now';
//         } else if (hoursAgo === 1) {
//             return "1 hour ago";
//         } else {
//             return `${hoursAgo} hours ago`;
//         }
//     } else if (hoursAgo < 48) {
//         return 'Yesterday';
//     } else {
//         const time = getFormattedDate(timeString);
//         return time;
//     }
// };

export const getRelativeTime = (timestamp) => {
    const now = new Date();
    const then = new Date(timestamp);

    const difference = now - then;
    const minutesAgo = Math.floor(difference / (1000 * 60));
    const hoursAgo = Math.floor(difference / (1000 * 60 * 60));
    const daysAgo = Math.floor(difference / (1000 * 60 * 60 * 24));
    const weeksAgo = Math.floor(difference / (1000 * 60 * 60 * 24 * 7));

    if (minutesAgo < 1) {
        return 'Now';
    } else if (minutesAgo < 60) {
        return `${minutesAgo}m`;
    } else if (hoursAgo < 24) {
        return `${hoursAgo}hr`;
    } else if (daysAgo < 7) {
        return `${daysAgo}d`;
    } else if (weeksAgo < 4) {
        return `${weeksAgo}w`;
    } else {
        const time = getFormattedDate(then);
        return time;
    }
};

export const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber?.startsWith('+1')) {
        return `+1 (${phoneNumber?.substring(2, 5)}) ${phoneNumber?.substring(5, 8)}-${phoneNumber?.substring(8)}`;
    }

    else if (phoneNumber?.startsWith('+91')) {
        return `+91 ${phoneNumber?.substring(3, 8)}-${phoneNumber?.substring(8)}`;
    }

    return phoneNumber;
}